import { useNavigation } from 'react-router';

import { useCurrentPage } from '@jane/bloom/hooks/navigation/useCurrentPage';
import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';
import {
  deriveBasename,
  stripBasename,
} from '@jane/bloom/utils/deriveBasename';

const useDestinationLocation = () => {
  const { menuUrl } = useRootLoaderData();
  // NB: destinationLocation contains the full path; it is *not* relative to React Router's route table.
  const { location: destinationLocation } = useNavigation();
  return stripBasename(destinationLocation?.pathname, deriveBasename(menuUrl));
};

export const useIsNavigatingAway = () => {
  const { state } = useNavigation();
  const destinationLocation = useDestinationLocation();
  const { pathname } = useCurrentPage();
  return Boolean(state === 'loading' && pathname !== destinationLocation);
};

/**
 * @param {RegExp} pathPattern - Regex pattern to test pending navigation route against
 * @returns {boolean} whether the page is navigating to a location matching input regex
 */
export const useIsNavigatingTo = (pathPattern: RegExp): boolean => {
  const destinationLocation = useDestinationLocation();
  const isNavigatingAway = useIsNavigatingAway();
  return Boolean(isNavigatingAway && destinationLocation.match(pathPattern));
};
